var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('common-title', {
    attrs: {
      "title": "为媒体提供高质量广告变现"
    },
    on: {
      "startAnimation": _vm.startAnimation
    }
  }, [_c('div', {
    staticClass: "padding-70 back-f margin-l-100 margin-r-100"
  }, [_c('div', {
    staticClass: "flexs jc-sa al-c"
  }, _vm._l(_vm.monetizationData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "flexs column pointer card-element",
      class: _vm.getCardAnimationClasses(index),
      on: {
        "mouseenter": function ($event) {
          return _vm.setHoverIndex(index);
        },
        "mouseleave": function ($event) {
          return _vm.setHoverIndex(-1);
        }
      }
    }, [_c('div', {
      staticClass: "flexs column jc-c margin-b-54"
    }, [_c('span', {
      staticClass: "fs-30 c-303650 f-700 margin-b-10"
    }, [_vm._v(_vm._s(item.label))]), _c('span', {
      staticClass: "fs-18 c-6"
    }, [_vm._v(_vm._s(item.content))])]), _c('img', {
      staticClass: "w-240 h-260",
      class: item.isAnimated ? 'custom-shake' : '',
      attrs: {
        "src": _vm.getImagePath(item.img),
        "alt": item.label
      }
    })]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };